import { getReportReasons, report } from '@/services/api/question';
import {
  ReportReasonResponse,
  ReportRequest,
  ReportResponse,
} from '@/types/api/question';
import { ApiErrorResponse } from '@/types/api/common';
import { useMutation, useQuery } from '@tanstack/react-query';

interface ReportOptions {
  loadReportReason?: boolean;
}

export const useReport = (option: ReportOptions = {}) => {
  const { loadReportReason = false } = option;
  const reportApi = useMutation<
    ReportResponse,
    ApiErrorResponse,
    ReportRequest
  >({
    mutationFn: (payload) => report(payload),
  });

  const getReportReasonApi = useQuery<ReportReasonResponse, ApiErrorResponse>({
    queryKey: ['report-reason'],
    queryFn: () => getReportReasons(),
    enabled: loadReportReason,
  });

  return {
    reportApi,
    getReportReasonApi,
  };
};
